/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_IntervalInputs */

const en_admin_subscriptions_interval = /** @type {(inputs: Admin_Subscriptions_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval`)
};

/**
* | output |
* | --- |
* | "Interval" |
*
* @param {Admin_Subscriptions_IntervalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_interval = /** @type {((inputs?: Admin_Subscriptions_IntervalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_IntervalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_interval(inputs)
});
export { admin_subscriptions_interval as "admin.subscriptions.interval" }